export default __webpack_public_path__ + "images/04e622b3d0471bceb6c86c681d9de0f8.svg";